import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React from "react";
import { Divider, makeStyles, Typography, RaiseColors } from "client/componentLibrary";
import DealroomlistingCardBadge from "components/ListingCard/DealroomlistingCardBadge";
import CoreAttributeText from "./CoreAttributeText";
import { trackEvent, TrackingEventContext, TrackingEventNames, TrackingEventPageView } from "utils/Analytics";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = makeStyles(function (theme) {
  return {
    cardContainer: _defineProperty({
      position: "relative",
      display: "flex",
      margin: "20px 8px 20px 0px"
    }, theme.breakpoints.down("smMd"), {
      flexDirection: "column",
      alignItems: "flex-start"
    }),
    carousel: {
      cursor: "pointer",
      "& img": {
        height: 172,
        width: 258,
        borderRadius: "4px",
        display: "block"
      }
    },
    body: _defineProperty({
      margin: "8px 40px 8px 20px",
      minWidth: 0,
      "&:hover": {
        cursor: "pointer"
      }
    }, theme.breakpoints.down("smMd"), {
      padding: "12px 0 8px 4px",
      width: "100%",
      margin: 0
    }),
    subtext: {
      margin: "4px 0px 2px 0px"
    },
    engagementSection: {
      display: "flex",
      marginLeft: "auto"
    },
    attributeText: {
      display: "flex",
      alignItems: "baseline"
    },
    leftAttributeContainer: {
      marginLeft: 8
    },
    divider: {
      margin: "8px 0px",
      width: "24px"
    },
    coreAttributes: {
      display: "flex",
      width: "264px",
      maxWidth: "264px"
    },
    dotIcon: {
      fontSize: "2px",
      color: RaiseColors.gray300,
      marginBottom: 3
    }
  };
});
var HorizontalListingCard = function HorizontalListingCard(_ref) {
  var FileCarouselSection = _ref.FileCarouselSection,
    CategoryDisplaySection = _ref.CategoryDisplaySection,
    listingName = _ref.listingName,
    listingType = _ref.listingType,
    neighborhood = _ref.neighborhood,
    coreAttributes = _ref.coreAttributes,
    EngagementSection = _ref.EngagementSection,
    _ref$useLineDivider = _ref.useLineDivider,
    useLineDivider = _ref$useLineDivider === void 0 ? true : _ref$useLineDivider,
    onCardClick = _ref.onCardClick,
    showClientActivityCount = _ref.showClientActivityCount,
    ClientActivityAttributes = _ref.ClientActivityAttributes,
    isListingsView = _ref.isListingsView,
    sublandlord = _ref.sublandlord;
  var classes = useStyles();
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs("div", {
      className: classes.cardContainer,
      "data-testid": "listing-card-container",
      children: [/*#__PURE__*/_jsx("div", {
        className: classes.carousel,
        "data-testid": "carousel-section",
        children: FileCarouselSection
      }), /*#__PURE__*/_jsxs("div", {
        className: classes.body,
        onClick: function onClick(e) {
          if (onCardClick) {
            onCardClick(e);
          }
          if (isListingsView) {
            trackEvent(TrackingEventNames.ELEMENT_PRESSED, {
              pageView: TrackingEventPageView.CLIENT_DEALROOM_LISTINGS,
              context: TrackingEventContext.LISTING_CARD
            });
          }
        },
        "data-testid": "listing-card-link",
        children: [CategoryDisplaySection && /*#__PURE__*/_jsxs("div", {
          "data-testid": "category-display-section",
          children: [CategoryDisplaySection, /*#__PURE__*/_jsx("div", {
            className: classes.divider,
            children: /*#__PURE__*/_jsx(Divider, {
              color: RaiseColors.gray100
            })
          })]
        }), /*#__PURE__*/_jsx(Typography, {
          noWrap: true,
          variant: "paragraph_medium",
          weight: "semibold",
          color: RaiseColors.black,
          display: "block",
          children: listingName
        }), /*#__PURE__*/_jsx("div", {
          className: classes.subtext,
          children: /*#__PURE__*/_jsxs(Typography, {
            color: RaiseColors.gray300,
            children: [neighborhood && "".concat(neighborhood, " \xB7"), listingType && " ".concat(listingType)]
          })
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(Typography, {
            color: RaiseColors.gray300,
            children: sublandlord
          })
        }), showClientActivityCount && /*#__PURE__*/_jsx("div", {
          "data-testid": "client-activity-count",
          children: /*#__PURE__*/_jsx(DealroomlistingCardBadge, {
            dealroomlisting: ClientActivityAttributes
          })
        }), coreAttributes && /*#__PURE__*/_jsxs("div", {
          className: classes.coreAttributes,
          children: [/*#__PURE__*/_jsxs("div", {
            style: {
              width: "50%"
            },
            children: [/*#__PURE__*/_jsx(CoreAttributeText, {
              isHorizontal: true,
              attribute: coreAttributes.sqft
            }), /*#__PURE__*/_jsx(CoreAttributeText, {
              isHorizontal: true,
              attribute: coreAttributes.term
            })]
          }), /*#__PURE__*/_jsxs("div", {
            style: {
              marginLeft: 20
            },
            children: [/*#__PURE__*/_jsx(CoreAttributeText, {
              isHorizontal: true,
              attribute: coreAttributes.askingRate
            }), /*#__PURE__*/_jsx(CoreAttributeText, {
              isHorizontal: true,
              attribute: coreAttributes.occupancy
            })]
          })]
        })]
      }), EngagementSection && /*#__PURE__*/_jsx("div", {
        className: classes.engagementSection,
        "data-testid": "engagement-section",
        children: EngagementSection
      })]
    }), useLineDivider && /*#__PURE__*/_jsx(Divider, {
      color: RaiseColors.gray100
    })]
  });
};
export default HorizontalListingCard;